import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../app/store";
import { resetAllFilters } from "../../app/store/reducers/appSlice";
import useTableData from "../../app/hooks/useTableData";
import { setGlobalFilter } from "../../app/store/reducers/appSlice";
import { ResetButtonRed } from "./styles"

interface ResetButtonProps {
    onReset?: () => void;
}

export default function ResetButton({ onReset }: ResetButtonProps) {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { getData } = useTableData();

    const handleReset = () => {
        dispatch(resetAllFilters());

        if (onReset) {
            onReset();
        }

        setTimeout(() => {
            getData({
                filter: { filter: {} },
                page: 1
            });
        }, 0);
    };

    return (
        <ResetButtonRed onClick={handleReset}>
            {t("Reset")}
        </ResetButtonRed>
    );
}